import { JsonProperty, JsonObject } from 'typescript-json-serializer';
import { UserGroup } from './user-group.model';
import { StationGroup } from './station-group';

/**
 * Container class for price rule information
 *
 * @export
 * @class PriceRule
 */
@JsonObject()
export class PriceRule {
  @JsonProperty('Id') id: string;
  @JsonProperty('ProductType') productType: ProductType;
  @JsonProperty('StationGroup') stationGroup: StationGroup;
  @JsonProperty('UserGroup') userGroup: UserGroup;
  @JsonProperty('Price') price: number;
  @JsonProperty('Currency') currency: string;
}

export enum ProductType {
  Parking = 'parking',
  Energy = 'energy',
}
